export default __webpack_public_path__ + "static/media/group1-shard1of1.3e53df0b.bin";